import { tryTransformPermalinkToLocalHref } from "./Permalinks";

/**
 * Converts a permalink to a local HREF and navigates accordingly. Throws if the permalink
 * cannot be transformed.
 * @param uri The permalink to navigate to.
 */
export function navigateToPermalink(uri: string): void {
    const localUri = tryTransformPermalinkToLocalHref(uri);
    if (!localUri || localUri === uri) {
        // parse failure can lead to an unmodified URL
        throw new Error("Failed to transform URI");
    }
    window.location.hash = localUri; // it'll just be a fragment
}
